import { ChangeEvent, KeyboardEvent, useCallback, useState } from "react";
import { searchLabelStyle, SearchSpacer } from "src/components/common/common";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionDoubleForm } from "src/components/common/form/search/SearchSectionDoubleForm";
import { defaultPRD3020_R01Filter, usePRD3020_R01Store } from "./Store_PRD3020_R01";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import useUiuxStore from "src/store/useUiuxStore";
import { EmployeeDto } from "src/types/base";
import { getEmployeeList } from "src/apis/employeeApi";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";

interface Props {
  onEnterKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void;
}

export const SearchSection_PRD3020_R01 = (props: Props) => {

	const { onEnterKeyDown } = props;

    const { setCodeSearchModalProps } = useUiuxStore();
	const { PRD3020_R01Filter, setPRD3020_R01Filter } = usePRD3020_R01Store();
	const { compCdList, workPlaceList, jobTeamList, yesNoList } = useCommonCodeStore();

	
    const [pickerVisible, setPickerVisible] = useState(false);
    const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

	const handleOrderEmpFoucsId = 'orderEmp_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'orderEmp',
			category: '작업자',
			focusId: handleOrderEmpFoucsId,
			responseMapping: {
				empNo: 'orderEmp',
				empNm: 'orderEmpNm',
			},
			extraFilter: () => ({
				orderEmp: PRD3020_R01Filter.orderEmp || '',
				orderEmpNm: PRD3020_R01Filter.orderEmpNm || '',
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({

		editData: PRD3020_R01Filter,
		setEditData: setPRD3020_R01Filter,
		defaultData: defaultPRD3020_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'PRD3020_R01_search'
	});

	return (
		<SearchSectionDoubleForm >
			{/* PRD2020Filter : {JSON.stringify(PRD3020_R01Filter)} <br /> */}
			<SearchDropDownForm
				label="사업장"
				value={PRD3020_R01Filter.compCd}
				onChangeItem={(item) => setPRD3020_R01Filter({ compCd: item?.compCd || ''})}
				optionList={compCdList}
				wrapperOption={{
					wrapperStyle: "w-[200px] min-w-[200px] mr-[10px]",
					titleStyle: "w-[45px] min-w-[45px] text-left",
					selectStyle: "w-[100px] min-w-[100px]",
				}}
			/>
			<SearchDateRangeForm
					label="생산일자"
					visible={pickerVisible}
					setVisible={setPickerVisible}
					dateRange={PRD3020_R01Filter.dateRange}
					setDateRange={v => setPRD3020_R01Filter({  dateRange: v})}
					pickerPosition={pickerPosition}
					setPickerPosition={setPickerPosition}
				/>
			<SearchDropDownForm
				label="작업공정"
				value={PRD3020_R01Filter.workplaceCd}
				onChangeItem={(item) => setPRD3020_R01Filter({ workplaceCd: item?.workplaceCd || ''})}
				optionList={workPlaceList.filter(opt => opt.compCd === PRD3020_R01Filter.compCd)}
				editable={PRD3020_R01Filter.compCd !== ''}
				wrapperOption={{
					wrapperStyle: "w-[200px] min-w-[200px] mr-[10px]",
					titleStyle: "w-[45px] min-w-[45px] text-left",
					selectStyle: "w-[100px] min-w-[100px]",
				}}
			/>
			<SearchCodeModalForm
				label="작업자"
				value={PRD3020_R01Filter.orderEmp}
				valueLabel={PRD3020_R01Filter.orderEmpNm}
				handleFoucsId={handleOrderEmpFoucsId}
				onChange={getFieldHandlers('orderEmp').onChange}
				onDoubleClick={getFieldHandlers('orderEmp').onDoubleClick}
				onKeyDown={getFieldHandlers('orderEmp').onEnterKeyDown}
				wrapperOption={{
					wrapperStyle: "w-[350px] min-w-[350px] mr-[10px]",
					titleStyle: "w-[70px] min-w-[70px] text-left",
					codeInputStyle: "w-[190px] min-w-[190px]",
					nameTagStyle: "w-[200px] min-w-[200px] text-left",
				}}
			/>
		</SearchSectionDoubleForm>
	);
};